import React from 'react'

import Button from 'components/Button'
import T from 'components/FormattedMessage'
import SocialShareLayer from 'components/SocialShareLayer'

import { getUserName, getShareURL } from 'store/modules/session/selectors'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { AppState } from 'store/types'
import { connect } from 'react-redux'

type Props = React.ComponentProps<typeof Button> & {
}

const mapStateToProps = ({ session }: AppState) => ({
  name: getUserName(session),
  shareURL: getShareURL(session),
})

type State = {
  layerOpen: boolean
}

type InjectedProps = Props & ReturnType<typeof mapStateToProps> & WrappedComponentProps

class InviteFriendsButton extends React.Component<InjectedProps, State> {
  constructor(props: InjectedProps) {
    super(props)
    this.state = {
      layerOpen: false,
    }
  }

  showLayer = () => {
    this.setState({ layerOpen: true })
  }

  hideLayer = () => {
    this.setState({ layerOpen: false })
  }

  render() {
    const { shareURL, intl, name, ...props } = this.props
    return (
      <>
        <Button color="primary" variant="contained" onClick={this.showLayer} {...props}>
          <T id="account_action_sharelink" />
        </Button>
        {this.state.layerOpen && (
          <SocialShareLayer
            url={shareURL}
            subject={intl.formatMessage({ id: 'account_action_sharelinksubject' }, { name })}
            text={intl.formatMessage({ id: 'account_action_sharelink_message' }, { shareURL })}
            onClose={this.hideLayer}
          />
        )}
      </>
    )
  }
}

export default connect(mapStateToProps, {})(injectIntl(InviteFriendsButton))
try {
    // @ts-ignore
    InviteFriendsButton.displayName = "InviteFriendsButton";
    // @ts-ignore
    InviteFriendsButton.__docgenInfo = { "description": "", "displayName": "InviteFriendsButton", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/InviteFriendsButton/InviteFriendsButton.tsx#InviteFriendsButton"] = { docgenInfo: InviteFriendsButton.__docgenInfo, name: "InviteFriendsButton", path: "src/components/InviteFriendsButton/InviteFriendsButton.tsx#InviteFriendsButton" };
}
catch (__react_docgen_typescript_loader_error) { }